/* ============================================
   UAF Scroll Animations
   IntersectionObserver for reveals + counter.
   ============================================ */

(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  /* --- Scroll Reveal Observer --- */
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  document
    .querySelectorAll('.uaf-reveal, .uaf-reveal--left, .uaf-reveal--right, .uaf-reveal--scale, .uaf-stagger')
    .forEach(function (el) {
      revealObserver.observe(el);
    });

  /* --- Animated Counter --- */
  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );

  document.querySelectorAll('.uaf-counter').forEach(function (el) {
    counterObserver.observe(el);
  });

  function animateCounter(el) {
    var target = parseFloat(el.getAttribute('data-target') || el.textContent);
    var duration = parseInt(el.getAttribute('data-duration') || '1500', 10);
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var decimals = (String(target).split('.')[1] || '').length;
    var start = 0;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = start + (target - start) * eased;

      el.textContent = prefix + formatNumber(current, decimals) + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  function formatNumber(num, decimals) {
    if (decimals > 0) {
      return num.toFixed(decimals);
    }
    return Math.round(num).toLocaleString('en-US');
  }

  /* --- Parallax Scroll (film showcase cards) --- */
  var parallaxEls = document.querySelectorAll('.uaf-parallax');
  if (parallaxEls.length > 0) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrollY = window.pageYOffset;
          parallaxEls.forEach(function (el) {
            var rect = el.getBoundingClientRect();
            var speed = parseFloat(el.getAttribute('data-parallax-speed') || '0.15');
            if (rect.top < window.innerHeight && rect.bottom > 0) {
              var offset = (scrollY - el.offsetTop) * speed;
              el.style.transform = 'translateY(' + offset + 'px)';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* --- Re-observe on Shopify section load (theme editor) --- */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      document
        .querySelectorAll('.uaf-reveal:not(.is-visible), .uaf-stagger:not(.is-visible)')
        .forEach(function (el) {
          revealObserver.observe(el);
        });
      document.querySelectorAll('.uaf-counter').forEach(function (el) {
        counterObserver.observe(el);
      });
    });
  }
})();
